import React from 'react';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';

const ActivityGridMore = () => {
    const colorText = text => {
        let letters = text.split('').map((char, index) => {
            return (
                <ColoredTitle key={index} index={index}>
                    {char}
                </ColoredTitle>
            );
        });
        return <LetterContainer>{letters}</LetterContainer>;
    };

    const {t} = useTranslation();

    return (
        <Container>
            {colorText(t('parentalPage.activities.moreLine1'))}
            <MiddleText>{t('parentalPage.activities.moreLine2')}</MiddleText>
            <EndText>{t('parentalPage.activities.moreLine3')}</EndText>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    background: linear-gradient(180deg, #0066ff 0%, #2fcdf2 100%);
    margin-top: 54px;
    align-items: center;
    justify-content: center;
    min-height: 200px;
`;

const ColoredTitle = styled.div`
    font-family: Rodger;
    font-weight: 900;
    font-size: 58px;
    line-height: 58px;
    text-align: center;
    color: ${props =>
        props.index % 3 === 0
            ? '#F6D703'
            : props.index % 3 === 1
            ? '#2bc7ee'
            : '#fba2d9'};
`;

const LetterContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
`;

const MiddleText = styled.div`
    font-family: 'Rodger';
    font-style: normal;
    font-weight: 900;
    font-size: 36px;
    text-align: center;
    margin-top: -4px;
    text-transform: uppercase;
`;

const EndText = styled.div`
    font-family: 'Rodger';
    font-style: normal;
    font-weight: 900;
    font-size: 46px;
    text-align: center;
    margin-top: -6px;
    text-transform: uppercase;
`;

export default ActivityGridMore;
